import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
// Removed Lenis for better performance
import { 
  Menu, X, Phone, Mail, MapPin, ArrowRight, 
  Home, Building2, Layout, Box, Compass, HardHat,
  Instagram, Facebook, Linkedin, MessageCircle,
  ChevronDown, Quote, ChevronLeft, ChevronRight
} from "lucide-react";

// Data
const services = [
  { id: 1, title: "Residential Interior Design", description: "Transforming homes into personalized sanctuaries that reflect your lifestyle and taste.", icon: Home, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/fqwe2eid_R1.jpg" },
  { id: 2, title: "Commercial Interior Design", description: "Creating inspiring workspaces that enhance productivity and brand identity.", icon: Building2, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/11ipmb1z_Commercial%20interior%20design.jpg" },
  { id: 3, title: "Space Planning & Layout", description: "Optimizing every square foot with intelligent spatial design solutions.", icon: Layout, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/sg8tkhe1_layout%20planning.jpg" },
  { id: 4, title: "3D Design & Visualization", description: "Bringing your vision to life with photorealistic 3D renderings before construction.", icon: Box, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/umbm4ol4_yogesh%20Residence%20.jpg" },
  { id: 5, title: "Event Space Planning", description: "Designing functional and aesthetically pleasing spaces for temples, events, and large gatherings.", icon: Compass, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/xohmf2it_Hassanamba%20Temple%202.jpg" },
  { id: 6, title: "Civil Work", description: "End-to-end construction and renovation services with precision execution.", icon: HardHat, image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/yx1a3yr3_Civil%20work.jpg" },
];

const projects = [
  { 
    id: 1, 
    title: "Mr. Natraj Residence", 
    category: "Residential", 
    location: "Bangalore", 
    description: "A contemporary home design blending modern aesthetics with traditional values. Features custom millwork, premium finishes, and thoughtfully designed spaces that maximize functionality while maintaining elegance.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/xop1guqe_1%20N.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/xop1guqe_1%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/s7mm6snv_2%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/llpmxhus_3%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/rg0dplug_4%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/ojdx9xi9_5%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/jomxnnxh_6%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/eocb65bx_7%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/eweu1vq2_8%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/adpixpsm_9%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/1vyu01lm_10%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/v5a4oo39_11%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/yf0q021w_12%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/1nx8i92r_13%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/fa3gblpl_14%20N.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/s29rb6bc_15%20N.jpg"
    ]
  },
  { 
    id: 2, 
    title: "Mr. Rakesh Residence", 
    category: "Residential", 
    location: "Bangalore", 
    description: "Elegant interiors featuring custom millwork, premium finishes, and stunning living spaces with contemporary design elements including beautiful pooja room, modern bathrooms, and luxurious living areas.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/h2e9k5vz_R4.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/fqwe2eid_R1.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/iqax8dly_R2.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/jpocua89_R3.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/h2e9k5vz_R4.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/llwru6b4_R5.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/8ipyqvg9_R6.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/35xw7sib_R7.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/rig6pg8j_R8.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/lb1acu93_R9.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/jqfb8999_R10.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/z1dabe4c_R11.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/i10t2hn5_R12.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/sd7pecm7_R13.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/d94gq1hc_R14.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/upy5dx9b_R15.jpg"
    ]
  },
  { 
    id: 3, 
    title: "Hassanamba Temple", 
    category: "Event Space Planning", 
    location: "Hassan", 
    description: "Sacred space infrastructure project for the renowned Hassanamba Temple. Designed crowd management walkways and structural elements to handle lakhs of devotees during the annual festival, blending modern functionality with traditional aesthetics.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/5k4kc81n_Hassanamba%20Temple%201.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/5k4kc81n_Hassanamba%20Temple%201.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/xohmf2it_Hassanamba%20Temple%202.jpg"
    ]
  },
  { 
    id: 4, 
    title: "Mr. RK Residence", 
    category: "Residential", 
    location: "Bangalore", 
    description: "Modern multi-story residential building featuring contemporary elevation design with wooden cladding, glass balconies, rooftop garden, and elegant lighting. A perfect blend of functionality and aesthetic appeal.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/wag0r248_Rk%201.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/wag0r248_Rk%201.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/2mesnqcp_Rk%202.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/na82esqx_Rk%203.jpg"
    ]
  },
  { 
    id: 5, 
    title: "Mr. Yogesh Residence", 
    category: "Residential", 
    location: "Bangalore", 
    description: "Luxury villa featuring contemporary architecture with natural stone accents, wooden elements, lush landscaping, and a covered car porch. Thoughtfully designed with multiple levels and balconies for maximum natural light.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/umbm4ol4_yogesh%20Residence%20.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/umbm4ol4_yogesh%20Residence%20.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/6woqgd9e_yogesh%20Residence%201.jpg"
    ]
  },
  { 
    id: 6, 
    title: "Mr. Ramesh Residence", 
    category: "Residential", 
    location: "Bangalore", 
    description: "Contemporary villa featuring modern architectural design with exposed brick accents, wooden cladding, rooftop garden, and thoughtfully designed outdoor spaces including a charming swing area.",
    image: "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/vnli6g7g_Ramesh%20Residence%202.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/mdf6z3h5_Ramesh%20Residence%201.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/vnli6g7g_Ramesh%20Residence%202.jpg",
      "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/d2ujgq6k_Ramesh%20Residence%203.jpg"
    ]
  },
];

const testimonials = [
  { id: 1, name: "Mr. Natraj", project: "Residential Interior", text: "AMG Dezign Studio transformed our house into a dream home. Their attention to detail and understanding of our requirements was exceptional. The kitchen and bedroom designs exceeded our expectations!", rating: 5 },
  { id: 2, name: "Mr. Rakesh", project: "Residential Interior", text: "Professional team with creative vision. They delivered beyond our expectations within the timeline and budget. The pooja room and living area designs are absolutely stunning!", rating: 5 },
  { id: 3, name: "Hassanamba Temple Committee", project: "Event Space Planning", text: "AMG Dezign Studio expertly handled the crowd management infrastructure for our annual festival. Their design accommodated lakhs of devotees safely and efficiently. Truly remarkable work!", rating: 5 },
  { id: 4, name: "Mr. RK", project: "Residential Elevation", text: "The exterior elevation design for our building is modern and elegant. Abhishek's team understood our vision perfectly and delivered a contemporary design with beautiful wooden cladding and glass elements.", rating: 5 },
  { id: 5, name: "Mr. Yogesh", project: "Villa Design", text: "Our villa looks absolutely magnificent! The stone accents, landscaping, and overall architectural design blend perfectly with nature. AMG Dezign Studio's 3D visualization helped us see our dream before it became reality.", rating: 5 },
  { id: 6, name: "Mr. Ramesh", project: "Residential Exterior", text: "The rooftop garden and outdoor spaces designed by AMG are our family's favorite spots now. The exposed brick and wooden elements give our home a unique character. Highly recommend their services!", rating: 5 },
];

// Navigation Component
const Navigation = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Portfolio", href: "#projects" },
    { name: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href) => {
    setIsOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'glass py-4' : 'py-6'
      }`}
      data-testid="navigation"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" onClick={() => scrollToSection('#home')} className="flex items-center gap-3" data-testid="logo">
          <img src="https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/ogc060pc_AMG%20logo.png" alt="AMG Logo" className="h-10 w-auto" />
          <span className="hidden sm:block text-amg-off-white font-body text-sm tracking-widest uppercase">Dezign Studio</span>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => scrollToSection(link.href)}
              className="nav-link font-body"
              data-testid={`nav-${link.name.toLowerCase()}`}
            >
              {link.name}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden lg:block">
          <button 
            onClick={() => scrollToSection('#contact')}
            className="btn-primary"
            data-testid="nav-get-quote-btn"
          >
            Get Quote
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className="lg:hidden text-amg-off-white p-2"
          data-testid="mobile-menu-btn"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden glass"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-amg-off-white font-body text-lg tracking-wider text-left hover:text-amg-gold transition-colors"
                >
                  {link.name}
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('#contact')}
                className="btn-primary mt-4"
              >
                Get Quote
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

// Hero Section
const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Use Natraj's project images for hero slider
  const heroImages = [
    "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/xop1guqe_1%20N.jpg",
    "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/s7mm6snv_2%20N.jpg",
    "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/v5a4oo39_11%20N.jpg",
    "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/yf0q021w_12%20N.jpg",
    "https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/fa3gblpl_14%20N.jpg"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 2000);
    
    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <section id="home" className="relative h-screen overflow-hidden" data-testid="hero-section">
      {/* Background Image Slider */}
      <div className="absolute inset-0">
        {heroImages.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img 
              src={img}
              alt={`Luxury Interior ${index + 1}`}
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-amg-bg/70" />
      </div>

      {/* Content */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 h-full flex items-center"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
          <div className="max-w-3xl">
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="hero-subtitle mb-6"
            >
              ARCHITECTURAL DESIGN STUDIO
            </motion.p>
            
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="hero-title text-amg-off-white mb-8"
              data-testid="hero-title"
            >
              Crafting Luxury Spaces,{" "}
              <span className="text-gold-gradient italic">Defining</span>{" "}
              Modern Living
            </motion.h1>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-amg-off-white/70 font-body text-lg mb-12 max-w-xl"
            >
              Transform your vision into reality with Bangalore's premier interior design studio. 
              Where elegance meets functionality.
            </motion.p>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="flex flex-wrap gap-4"
            >
              <a href="#projects" className="btn-primary inline-flex items-center gap-2" data-testid="hero-explore-btn">
                Explore Projects <ArrowRight size={18} />
              </a>
              <a href="#contact" className="btn-outline" data-testid="hero-contact-btn">
                Start Your Project
              </a>
            </motion.div>
          </div>
        </div>
      </motion.div>

      {/* Slide Indicators */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-amg-gold w-8' : 'bg-white/30'
            }`}
            data-testid={`hero-slide-${index}`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span className="text-amg-gold text-xs tracking-widest uppercase font-body">Scroll</span>
        <ChevronDown className="text-amg-gold animate-bounce" size={20} />
      </motion.div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-amg-bg" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <p className="section-label mb-4">About Us</p>
          <h2 className="section-title text-amg-off-white">
            Where Vision Meets <span className="text-amg-gold italic">Craftsmanship</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-amg-off-white/80 font-body text-lg leading-relaxed mb-8">
              AMG Dezign Studio is a Bangalore-based Design firm dedicated to creating 
              spaces that inspire and transform. With expertise spanning residential and commercial 
              projects, we blend contemporary aesthetics with timeless elegance.
            </p>
            <p className="text-amg-off-white/60 font-body leading-relaxed mb-12">
              Our approach combines innovative design thinking with meticulous attention to detail, 
              ensuring every project reflects our clients' unique personalities while maintaining 
              the highest standards of quality and functionality.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <span className="font-accent text-4xl text-amg-gold">50+</span>
                <p className="text-amg-off-white/60 text-sm mt-2 font-body">Projects Completed</p>
              </div>
              <div>
                <span className="font-accent text-4xl text-amg-gold">8+</span>
                <p className="text-amg-off-white/60 text-sm mt-2 font-body">Years Experience</p>
              </div>
              <div>
                <span className="font-accent text-4xl text-amg-gold">100%</span>
                <p className="text-amg-off-white/60 text-sm mt-2 font-body">Client Satisfaction</p>
              </div>
            </div>
          </motion.div>

          {/* Founder Card */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="bg-amg-surface border border-white/5 p-8 md:p-12">
              <div className="flex flex-col md:flex-row gap-8 items-start">
                <div className="w-40 h-52 md:w-48 md:h-64 flex-shrink-0 overflow-hidden">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/l7jjdv0z_Untitled%20design%20%2816%29.png"
                    alt="Abhishek G - Founder"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-amg-gold text-xs tracking-widest uppercase mb-2 font-body">Founder & Principal Designer</p>
                  <h3 className="font-heading text-2xl text-amg-off-white mb-4">Abhishek G</h3>
                  <p className="text-amg-off-white/60 font-body text-sm leading-relaxed mb-4">
                    A BIM Architect from Bangalore with a Bachelor of Science in Interior Design and Decoration, 
                    complemented by specialized architectural training.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="text-xs bg-amg-gold/10 text-amg-gold px-3 py-1 font-body">BIM Architect</span>
                    <span className="text-xs bg-amg-gold/10 text-amg-gold px-3 py-1 font-body">B.Sc. Interior Design</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-amg-gold/20 -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-amg-surface" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 max-w-2xl"
        >
          <p className="section-label mb-4">Our Services</p>
          <h2 className="section-title text-amg-off-white mb-6">
            Comprehensive Design <span className="text-amg-gold italic">Solutions</span>
          </h2>
          <p className="text-amg-off-white/60 font-body">
            From concept to completion, we offer end-to-end all design services 
            tailored to your unique requirements.
          </p>
        </motion.div>

        {/* Services Grid - Bento Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="service-card group"
              data-testid={`service-card-${service.id}`}
            >
              <div className="flex flex-col">
                <div className="h-48 overflow-hidden mb-6">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div>
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 border border-amg-gold/30 flex items-center justify-center group-hover:border-amg-gold group-hover:bg-amg-gold/10 transition-all duration-300">
                      <service.icon className="text-amg-gold" size={24} />
                    </div>
                    <span className="text-amg-gold/50 font-accent text-sm">0{service.id}</span>
                  </div>
                  <h3 className="font-heading text-xl text-amg-off-white mb-4 group-hover:text-amg-gold transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-amg-off-white/60 font-body text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Project Modal with Carousel
const ProjectModal = ({ project, isOpen, onClose }) => {
  const [currentImage, setCurrentImage] = useState(0);
  
  if (!isOpen || !project) return null;

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % project.gallery.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + project.gallery.length) % project.gallery.length);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 md:p-8"
        onClick={onClose}
        data-testid="project-modal"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="bg-amg-surface max-w-5xl w-full max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/70 hover:text-white z-10 p-2"
            data-testid="modal-close-btn"
          >
            <X size={28} />
          </button>

          {/* Image Carousel */}
          <div className="relative aspect-video bg-amg-bg">
            <img
              src={project.gallery[currentImage]}
              alt={`${project.title} - Image ${currentImage + 1}`}
              className="w-full h-full object-cover"
            />
            
            {project.gallery.length > 1 && (
              <>
                {/* Navigation Arrows */}
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-amg-gold/80 flex items-center justify-center transition-colors"
                  data-testid="carousel-prev"
                >
                  <ChevronLeft size={24} className="text-white" />
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-black/50 hover:bg-amg-gold/80 flex items-center justify-center transition-colors"
                  data-testid="carousel-next"
                >
                  <ChevronRight size={24} className="text-white" />
                </button>

                {/* Image Counter */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 px-4 py-2 text-white text-sm font-body">
                  {currentImage + 1} / {project.gallery.length}
                </div>

                {/* Dots */}
                <div className="absolute bottom-4 right-4 flex gap-2">
                  {project.gallery.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImage(index)}
                      className={`w-2 h-2 rounded-full transition-all ${
                        index === currentImage ? 'bg-amg-gold w-6' : 'bg-white/50'
                      }`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Project Info */}
          <div className="p-8">
            <div className="flex items-center gap-4 mb-4">
              <span className="text-amg-gold text-xs tracking-widest uppercase font-body">
                {project.category}
              </span>
              <span className="text-amg-off-white/50 text-xs font-body flex items-center gap-1">
                <MapPin size={12} /> {project.location}
              </span>
            </div>
            <h3 className="font-heading text-3xl text-amg-off-white mb-4">
              {project.title}
            </h3>
            <p className="text-amg-off-white/70 font-body leading-relaxed">
              {project.description}
            </p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

// Portfolio Section (renamed from Clients)
const PortfolioSection = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [activeFilter, setActiveFilter] = useState("All");
  const filters = ["All", "Residential", "Event Space Planning"];
  
  const filteredProjects = activeFilter === "All" 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="projects" className="py-24 md:py-32 bg-amg-bg" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="section-label mb-4">Our Portfolio</p>
          <h2 className="section-title text-amg-off-white mb-4">
            Trusted by <span className="text-amg-gold italic">Discerning</span> Clients
          </h2>
          <p className="text-amg-off-white/60 font-body max-w-2xl mb-8">
            We take pride in delivering exceptional results for our valued clients across Bangalore and beyond.
          </p>
          
          {/* Filters */}
          <div className="flex gap-2" data-testid="portfolio-filters">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                data-testid={`filter-${filter.toLowerCase()}`}
              >
                {filter}
              </button>
            ))}
          </div>
        </motion.div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group cursor-pointer"
              onClick={() => setSelectedProject(project)}
              data-testid={`portfolio-card-${project.id}`}
            >
              <div className="relative h-72 overflow-hidden mb-6">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-amg-bg via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="text-amg-gold text-xs tracking-widest uppercase font-body">
                    {project.category}
                  </span>
                </div>
                {/* View indicator */}
                <div className="absolute inset-0 bg-amg-gold/0 group-hover:bg-amg-gold/10 transition-colors duration-300 flex items-center justify-center">
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm uppercase tracking-widest font-body">
                    View Project
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-xl text-amg-off-white mb-2 group-hover:text-amg-gold transition-colors duration-300">
                {project.title}
              </h3>
              <p className="text-amg-off-white/50 font-body text-sm flex items-center gap-2">
                <MapPin size={14} className="text-amg-gold" />
                {project.location}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Project Modal */}
      <ProjectModal
        project={selectedProject}
        isOpen={!!selectedProject}
        onClose={() => setSelectedProject(null)}
      />
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 md:py-32 bg-amg-bg" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <p className="section-label mb-4">Testimonials</p>
          <h2 className="section-title text-amg-off-white">
            What Our Clients <span className="text-amg-gold italic">Say</span>
          </h2>
        </motion.div>

        {/* Testimonials Carousel */}
        <div className="max-w-4xl mx-auto relative">
          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-12 h-12 border border-amg-gold/30 flex items-center justify-center hover:border-amg-gold hover:bg-amg-gold/10 transition-all z-10"
            data-testid="testimonial-prev"
          >
            <ChevronLeft size={24} className="text-amg-gold" />
          </button>
          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-12 h-12 border border-amg-gold/30 flex items-center justify-center hover:border-amg-gold hover:bg-amg-gold/10 transition-all z-10"
            data-testid="testimonial-next"
          >
            <ChevronRight size={24} className="text-amg-gold" />
          </button>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="testimonial-card text-center"
              data-testid={`testimonial-${activeIndex}`}
            >
              <Quote className="text-amg-gold mx-auto mb-8 opacity-30" size={48} />
              <p className="font-heading text-xl md:text-2xl text-amg-off-white leading-relaxed mb-8">
                "{testimonials[activeIndex].text}"
              </p>
              <div>
                <p className="font-heading text-lg text-amg-gold">{testimonials[activeIndex].name}</p>
                <p className="text-amg-off-white/50 font-body text-sm">{testimonials[activeIndex].project}</p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Dots */}
          <div className="flex justify-center gap-3 mt-12">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === activeIndex ? 'bg-amg-gold w-8' : 'bg-amg-gold/30'
                }`}
                data-testid={`testimonial-dot-${index}`}
              />
            ))}
          </div>

          {/* Counter */}
          <div className="text-center mt-6">
            <span className="text-amg-off-white/50 font-body text-sm">
              {activeIndex + 1} / {testimonials.length}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-amg-surface" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="section-label mb-4">Get in Touch</p>
            <h2 className="section-title text-amg-off-white mb-8">
              Let's Create Something <span className="text-amg-gold italic">Beautiful</span>
            </h2>
            <p className="text-amg-off-white/60 font-body mb-12 max-w-md">
              Ready to transform your space? Contact us today for a free consultation 
              and let's discuss your dream project.
            </p>

            <div className="space-y-6">
              <a 
                href="tel:+917204488547" 
                className="flex items-center gap-4 text-amg-off-white hover:text-amg-gold transition-colors group"
                data-testid="contact-phone"
              >
                <div className="w-12 h-12 border border-amg-gold/30 flex items-center justify-center group-hover:border-amg-gold group-hover:bg-amg-gold/10 transition-all">
                  <Phone size={20} className="text-amg-gold" />
                </div>
                <div>
                  <p className="font-body text-sm text-amg-off-white/50">Call Us</p>
                  <p className="font-body">+91 72044 88547</p>
                </div>
              </a>

              <a 
                href="mailto:ceo@amgdezignstudio.com"
                className="flex items-center gap-4 text-amg-off-white hover:text-amg-gold transition-colors group"
                data-testid="contact-email"
              >
                <div className="w-12 h-12 border border-amg-gold/30 flex items-center justify-center group-hover:border-amg-gold group-hover:bg-amg-gold/10 transition-all">
                  <Mail size={20} className="text-amg-gold" />
                </div>
                <div>
                  <p className="font-body text-sm text-amg-off-white/50">Email Us</p>
                  <p className="font-body">ceo@amgdezignstudio.com</p>
                </div>
              </a>

              <div className="flex items-start gap-4 text-amg-off-white">
                <div className="w-12 h-12 border border-amg-gold/30 flex items-center justify-center flex-shrink-0">
                  <MapPin size={20} className="text-amg-gold" />
                </div>
                <div>
                  <p className="font-body text-sm text-amg-off-white/50">Visit Us</p>
                  <p className="font-body">
                    #8, Shiva Shakthi Nilaya, 2nd Cross,<br />
                    Vishweshwariah Layout, RT Nagar,<br />
                    Bengaluru, Karnataka 560032
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <form onSubmit={handleSubmit} className="space-y-8" data-testid="contact-form">
              {submitStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500/50 text-green-400 px-4 py-3 font-body text-sm">
                  Thank you for your inquiry! We will get back to you soon.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500/50 text-red-400 px-4 py-3 font-body text-sm">
                  Something went wrong. Please try again or contact us directly.
                </div>
              )}
              <div>
                <input
                  type="text"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="input-underline"
                  required
                  data-testid="contact-name-input"
                />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="input-underline"
                  required
                  data-testid="contact-email-input"
                />
              </div>
              <div>
                <input
                  type="tel"
                  placeholder="Your Phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="input-underline"
                  required
                  data-testid="contact-phone-input"
                />
              </div>
              <div>
                <textarea
                  placeholder="Tell us about your project"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="input-underline min-h-32 resize-none"
                  required
                  data-testid="contact-message-input"
                />
              </div>
              <button 
                type="submit" 
                className="btn-primary w-full disabled:opacity-50" 
                disabled={isSubmitting}
                data-testid="contact-submit-btn"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-16 bg-amg-bg border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-heading text-3xl text-amg-gold">AMG</span>
              <span className="text-amg-off-white font-body text-sm tracking-widest uppercase">Dezign Studio</span>
            </div>
            <p className="text-amg-off-white/60 font-body max-w-sm mb-6">
              Creating exceptional Architectural & Interior spaces that inspire and transform. 
              Your vision, our expertise.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 border border-amg-gold/30 flex items-center justify-center hover:border-amg-gold hover:bg-amg-gold/10 transition-all" data-testid="social-instagram">
                <Instagram size={18} className="text-amg-gold" />
              </a>
              <a href="#" className="w-10 h-10 border border-amg-gold/30 flex items-center justify-center hover:border-amg-gold hover:bg-amg-gold/10 transition-all" data-testid="social-facebook">
                <Facebook size={18} className="text-amg-gold" />
              </a>
              <a href="#" className="w-10 h-10 border border-amg-gold/30 flex items-center justify-center hover:border-amg-gold hover:bg-amg-gold/10 transition-all" data-testid="social-linkedin">
                <Linkedin size={18} className="text-amg-gold" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-amg-off-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Projects', 'Contact'].map((link) => (
                <li key={link}>
                  <a href={`#${link.toLowerCase()}`} className="footer-link font-body">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg text-amg-off-white mb-6">Services</h4>
            <ul className="space-y-3">
              {['Residential Design', 'Commercial Design', '3D Visualization', 'Civil Work'].map((service) => (
                <li key={service}>
                  <span className="footer-link font-body">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-amg-off-white/40 font-body text-sm">
            © {currentYear} AMG Dezign Studio. All rights reserved.
          </p>
          <p className="text-amg-off-white/40 font-body text-sm">
            Designed with passion in Bangalore
          </p>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Button with proper logo
const WhatsAppButton = () => {
  return (
    <a 
      href="https://wa.me/917204488547"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
      data-testid="whatsapp-btn"
    >
      <svg 
        viewBox="0 0 32 32" 
        fill="white" 
        width="28" 
        height="28"
      >
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.156-1.972C9.77 30.994 12.754 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.316 22.594c-.39 1.1-1.932 2.014-3.182 2.28-.854.182-1.968.326-5.72-1.23-4.798-1.988-7.878-6.85-8.118-7.166-.23-.316-1.938-2.58-1.938-4.92s1.228-3.49 1.664-3.97c.39-.43.91-.614 1.38-.614.172 0 .326.008.466.016.436.018.654.044.942.728.36.856 1.24 3.016 1.348 3.236.11.22.22.516.072.816-.14.308-.264.444-.484.698-.22.254-.428.448-.648.722-.198.238-.422.494-.176.942.246.448 1.094 1.802 2.35 2.92 1.616 1.436 2.978 1.882 3.398 2.092.322.16.704.136.958-.128.322-.338.72-.898 1.124-1.448.288-.394.65-.444 1.006-.308.36.128 2.276 1.072 2.666 1.268.39.196.65.29.746.456.094.166.094.956-.296 2.056z"/>
      </svg>
    </a>
  );
};

// Main Home Component
const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Scroll handler for navbar
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="bg-amg-bg min-h-screen" data-testid="home-page">
      <Navigation isScrolled={isScrolled} />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PortfolioSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// Admin Page Component
const AdminPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (response.ok) {
        setIsLoggedIn(true);
        sessionStorage.setItem('amg_admin', 'true');
        fetchInquiries();
      } else {
        setError('Invalid password');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    }
  };

  const fetchInquiries = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`);
      const data = await response.json();
      setInquiries(data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
    } catch (err) {
      console.error('Error fetching inquiries:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('amg_admin') === 'true') {
      setIsLoggedIn(true);
      fetchInquiries();
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('amg_admin');
    setIsLoggedIn(false);
    setPassword('');
  };

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-amg-bg flex items-center justify-center px-4">
        <div className="bg-amg-surface p-8 max-w-md w-full border border-white/10">
          <div className="text-center mb-8">
            <img src="https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/ogc060pc_AMG%20logo.png" alt="AMG Logo" className="h-12 mx-auto mb-4" />
            <h1 className="font-heading text-2xl text-amg-off-white">Admin Login</h1>
            <p className="text-amg-off-white/50 font-body text-sm mt-2">Enter password to access inquiries</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-6">
            {error && (
              <div className="bg-red-500/20 border border-red-500/50 text-red-400 px-4 py-3 font-body text-sm">
                {error}
              </div>
            )}
            <input
              type="password"
              placeholder="Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-underline"
              required
            />
            <button type="submit" className="btn-primary w-full">
              Login
            </button>
          </form>
          <button onClick={() => navigate('/')} className="w-full mt-4 text-amg-gold/70 hover:text-amg-gold font-body text-sm">
            ← Back to Website
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-amg-bg">
      {/* Admin Header */}
      <div className="bg-amg-surface border-b border-white/10 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_50d4f98d-d846-42a7-ae77-5bcbc4d895c0/artifacts/ogc060pc_AMG%20logo.png" alt="AMG Logo" className="h-8" />
            <span className="text-amg-off-white font-body text-sm tracking-widest uppercase">Admin Panel</span>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/')} className="text-amg-off-white/70 hover:text-amg-gold font-body text-sm">
              View Website
            </button>
            <button onClick={handleLogout} className="btn-outline text-xs py-2 px-4">
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Admin Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="font-heading text-3xl text-amg-off-white">Contact Inquiries</h1>
          <button onClick={fetchInquiries} className="btn-primary text-xs py-2 px-4">
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <p className="text-amg-off-white/50 font-body">Loading inquiries...</p>
          </div>
        ) : inquiries.length === 0 ? (
          <div className="text-center py-12 bg-amg-surface border border-white/10">
            <p className="text-amg-off-white/50 font-body">No inquiries yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {inquiries.map((inquiry) => (
              <div key={inquiry.id} className="bg-amg-surface border border-white/10 p-6">
                <div className="flex flex-wrap items-start justify-between gap-4 mb-4">
                  <div>
                    <h3 className="font-heading text-xl text-amg-off-white">{inquiry.name}</h3>
                    <p className="text-amg-gold font-body text-sm">{inquiry.email}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-amg-off-white/50 font-body text-xs">
                      {new Date(inquiry.created_at).toLocaleDateString('en-IN', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </p>
                    <p className="text-amg-off-white font-body text-sm mt-1">
                      <Phone size={12} className="inline mr-1" />
                      {inquiry.phone}
                    </p>
                  </div>
                </div>
                <p className="text-amg-off-white/80 font-body leading-relaxed bg-amg-bg/50 p-4">
                  {inquiry.message}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
